import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  MenuItem,
  Button,
  Box,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  useDisclosure
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { SiSap } from 'react-icons/si'

import useMrpPurchase from '@hook/mrp/use-purchase'
import useTools from '@hook/shared/use-tools'

import Filter from '@component/Shared/Filter'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ActionSAPExport: FC<ILayoutToolsExportAction> = ({ data, sapModal }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    handleUpdateSapParams,
    paramsSap,
    exportDataSapCsv,
    supplyMethod,
    discountSupply
  } = useMrpPurchase()
  const { isDisabled } = useTools()
  const [loading, setLoading] = useState(false)
  const [valueDesconto, setDesconto] = useState('')
  const unique = [
    ...new Set(
      data.map(item => item.estoque?.produtoFornecedor?.fornecedor?.codigo)
    )
  ]

  const validateSap = () => {
    if (
      discountSupply.metodoPagamentoId === paramsSap.metodoPagamento[0]?.value
    ) {
      if (valueDesconto < discountSupply.desconto) {
        setDesconto(discountSupply.desconto.toString())
      }
    }
  }
  const defaultDiscount = (value: any) => {
    if (discountSupply.metodoPagamentoId === value[0]?.value) {
      setDesconto(discountSupply.desconto.toString())
    }
  }

  if (unique.length === 1) {
    return (
      <>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          motionPreset="slideInBottom"
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader bgColor="white">Exportar para SAP/Viasoft</ModalHeader>
            <ModalCloseButton />
            <ModalBody bgColor="white">
              <Box w="100%">
                <FormControl id="discount">
                  <FormLabel>Desconto </FormLabel>
                  <NumberInput
                    borderColor="blackAlpha.400"
                    value={valueDesconto}
                    onChange={value => setDesconto(value)}
                    onBlur={(event: any) => {
                      validateSap()
                      handleUpdateSapParams({
                        name: 'desconto',
                        value: event.target.value
                      })
                    }}
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
              </Box>
              <br></br>
              <Filter
                label="Forma de Pagamento"
                options={supplyMethod.map(paymentMethod => ({
                  label: `${paymentMethod.codigo} - ${paymentMethod.descricao}`,
                  value: paymentMethod.id
                }))}
                value={paramsSap.metodoPagamento}
                isMulti
                onChange={value => {
                  defaultDiscount(value)
                  handleUpdateSapParams({ name: 'metodoPagamento', value })
                }}
              />
            </ModalBody>
            <ModalFooter bgColor="white">
              <Button
                variant="ghost"
                color="black"
                onClick={() => {
                  exportDataSapCsv()
                  onClose()
                }}
                isDisabled={!supplyMethod}
              >
                Exportar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <MenuItem
          p="2px 12px"
          fontSize="sm"
          _hover={{ bg: 'gray.400' }}
          onClick={() => {
            onOpen()
            setLoading(false)
          }}
          isDisabled={isDisabled}
        >
          Exportar para SAP/Viasoft
        </MenuItem>
      </>
    )
  } else if (sapModal && data.length > 0 && loading) {
    exportDataSapCsv()
    setLoading(false)
  }

  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      icon={<SiSap />}
      onClick={() => {
        setLoading(true)
      }}
      isDisabled={isDisabled}
    >
      Exportar para SAP/Viasoft
    </MenuItem>
  )
}

export default ActionSAPExport
